const EASING = "ease";

type Input = {
  canTransition: boolean;
  duration: number;
  panelElement: HTMLDivElement;
};

export const setTransitionStyles = (input: Input) => {
  const { canTransition, duration, panelElement } = input;
  if (!canTransition) {
    panelElement.style.removeProperty("transition");
    return;
  }

  // 競合を避けるため inline で transition を明示
  panelElement.style.setProperty(
    "transition",
    `height ${duration}ms ${EASING}, opacity ${duration}ms ${EASING}`,
    "important"
  );
};
